import { render, staticRenderFns } from "./SectionText.vue?vue&type=template&id=174c73a0&"
import script from "./SectionText.vue?vue&type=script&lang=js&"
export * from "./SectionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports